const AgricultureQuery = (id) => {
    return `
    query {
        getAgricultureById(id: "${id}") {
          id
          group_id,
          form_id,
          AgricultureFormData {
            new_profile_agriculture_emp_name
            new_profile_agriculture_worksite_address
			      new_profile_agriculture_city
			      new_profile_agriculture_state
			      new_profile_agriculture_county{
              value,
              label
            }
			      new_profile_agriculture_zip
			      new_profile_agriculture_add_emp_info
            new_profile_agriculture_profile_name
          }
        }
      }
      `
}

export const AgriculturesQuery = (id) => {
    return `
    query {
        getAgricultureByIds(ids: ${id}) {
          id
          group_id,
          form_id,
          AgricultureFormData {
            new_profile_agriculture_emp_name
            new_profile_agriculture_worksite_address
			      new_profile_agriculture_city
			      new_profile_agriculture_state
			      new_profile_agriculture_county{
              value,
              label
            }
			      new_profile_agriculture_zip
			      new_profile_agriculture_add_emp_info
            new_profile_agriculture_profile_name
          }
        }
      }
      `
}

export default AgricultureQuery;